import createCrudVuexModule from "@/store/crud";

/** TKP-162 — tedbir kütüphanesi (library_measure): organizasyon tarafı okur (`/library/measure`), çalışma alanı yönetir. */
export const measure = createCrudVuexModule({
  namespaced: true,
  path: "/library/measure",
  moduleName: `measure`,
});

export const workspaceMeasure = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/measure",
});

export const managementMeasure = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/measure",
});
